import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FreightConfigurationActivity extends Component {
	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Freight/FreightConfiguration/FreightConfigurationForm")
	}

	render() {
		return (
			<Activity 
				name="FreightConfiguration"
				RenderedComponent={this.RenderedComponent}
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FreightConfigurationActivity)